import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Switch from 'react-switch';
import i18n from 'i18n-react';


import { Toast } from 'C4';

export default class SwitchButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      completed: false,
      switchState: false,
      answerCorrect: false,
      toastContent: null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.checkAnswer = this.checkAnswer.bind(this);
  }

  handleChange() {
    const { switchState, completed } = this.state;
    const { answersCorrect } = this.props;

    if (!completed) {
      this.setState({ switchState: !switchState, answerCorrect: answersCorrect[(!switchState ? 0 : 1)] === 'true' });
    } else this.setState({ switchState });
  }

  checkAnswer() {
    const { answerCorrect, completed } = this.state;
    const { correctAnswerText, incorrectAnswerText, contentComplete } = this.props;

    if (!completed) {
      if (answerCorrect) {
        this.setState({
          completed: true,
          toastContent: {
            content: correctAnswerText,
            position: 'bottom-center',
          },
        });
        contentComplete();
      } else {
        // this.setState({
        //   toastContent: {
        //     type: 'error',
        //     content: incorrectAnswerText,
        //     position: 'bottom-center',
        //   },
        // });
      }
    }
  }

  render() {
    const { question, error, disableToast } = this.props;
    const { switchState, toastContent } = this.state;

    return (
      <div className="container__question">
        <div className="container__question--content">
          <h4 className="container__title">{question}</h4>
          <div className="container__switch">
            <Switch
              onChange={this.handleChange}
              checked={switchState}
              className="react-switch"
              id="normal-switch"
              offColor="#c20000"
              height={40}
              width={80}
            />
            <h4>{i18n.translate(`trainingScreens.${switchState}`)}</h4>
          </div>
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => { this.setState({ toastContent: null }); }}
              {...toastContent}
            />
          )}
          <button onClick={this.checkAnswer}>{i18n.translate('trainingScreens.confirm')}</button>
        </div>
        {error(false)}
      </div>
    );
  }
}

SwitchButton.propTypes = {
  answersCorrect: PropTypes.arrayOf(PropTypes.string).isRequired,
  contentComplete: PropTypes.func,
  correctAnswerText: PropTypes.string,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  layout: PropTypes.string,
  question: PropTypes.string,
  disableToast: PropTypes.bool,
};

SwitchButton.defaultProps = {
  contentComplete: false,
  correctAnswerText: '',
  error: () => { },
  incorrectAnswerText: '',
  layout: 'mMC',
  question: '',
  disableToast: false,
};
